type ContextId = string | 'unmanaged';
export interface HelpCenterContext {
  messageTemplate?: string;
  selectedTopic?: string;
}
export interface HelpCenterState {
  contexts: Record<ContextId, HelpCenterContext>;
  currentContext?: string;
  topicToBeOpened?: string;
}

export const initialHelpCenterState: HelpCenterState = {
  contexts: {},
};
